import config from './global.config'
import api from "@/http";
import loggerInstance from "@/utility/Logger";

function LocalStorage() {
  this.localStorage = localStorage;
  this.defaultTTL = config.get('local_storage_ttl');
}

//Mapping Method For Quick Swap
LocalStorage.prototype.getItem = function(keyName) {
  return this.getData(keyName)
}

//Mapping Method For Quick Swap
LocalStorage.prototype.saveData = function (keyName, dataValue) {
  return this.saveData(keyName, dataValue, this.defaultTTL);
}

//Mapping Method For Quick Swap
LocalStorage.prototype.removeItem = function (keyName) {
  return this.deleteData(keyName)
}

LocalStorage.prototype.deleteData = function (keyName) {
  this.localStorage.removeItem(keyName)

  return this
}

LocalStorage.prototype.getData = function(keyName, defaultValue) {
  const dataObject = JSON.parse(this.localStorage.getItem(keyName));

  loggerInstance.log('Loading From Local Storage', keyName, defaultValue)
  if (!dataObject) {
    loggerInstance.log('Local Storage Empty')
    return defaultValue.value;
  } else if (dataObject.ttl <= new Date().getTime()) {
    loggerInstance.log('Local Storage Expired')
    this.deleteData(keyName);
    return null;
  }
  loggerInstance.log('Local Storage Not Expired');
  return dataObject.value;


}

//Helper Method For Making Easy Chains With Promises
LocalStorage.prototype.getDataPromise = function (keyName) {
  let self = this;

  return new Promise((resolve, reject) => {
      const data = self.getData(keyName, null);
      if (!data) {
        reject()
      } else {
        resolve(data);
      }
    }
  )
}

LocalStorage.prototype.getUrl = function(url, apiMethod) {
  const self = this
  apiMethod = apiMethod || 'get'

  return this.getDataPromise(url).catch(() => {
    loggerInstance.log('Failed To Pull From Local Storage, Loading From Server', url)
    return api.authenticated().then(() => {
      return api[apiMethod](config.applicationUrl(url)).then(
        (data) => {
          self.saveData(url, data.data)
          return data.data
        }
      )
    })
  })
}

LocalStorage.prototype.saveData = function(keyName, dataValue, ttl) {
  ttl = ttl || this.defaultTTL;
  const dataObject = {
    value: dataValue,
    ttl: new Date().getTime() + ttl
  }

  loggerInstance.log('Saving Local Storage', keyName, dataObject)

  this.localStorage.setItem(keyName, JSON.stringify(dataObject));

  return this
}

const localInstance = new LocalStorage()

export default localInstance
